export default __webpack_public_path__ + "static/media/arbox-loader.bf85768b.gif";